import axios, { AxiosError } from 'axios';
import { useRuntimeConfig } from '#imports';
import type {
   TournamentEntrySubmitPayload,
   TournamentEntrySubmitResponse,
   TournamentEntrySubmitErrors,
} from '~/types/types';

export type SubmitOutcome =
   | { status: 'success'; entryId: number }
   | { status: 'validation'; errors: TournamentEntrySubmitErrors }
   | { status: 'rate_limited' }
   | { status: 'error'; message: string };

interface LaravelValidationEnvelope {
   message?: string;
   errors?: TournamentEntrySubmitErrors;
}

export async function submitTournamentEntry(
   payload: TournamentEntrySubmitPayload
): Promise<SubmitOutcome> {
   const config = useRuntimeConfig();
   const baseUrl = config.public.lmsApiBaseurl as string;

   try {
      const response = await axios.post<TournamentEntrySubmitResponse>(
         `${baseUrl}tournament-entries`,
         payload
      );
      return { status: 'success', entryId: response.data.entry_id };
   } catch (e) {
      const axiosError = e as AxiosError<LaravelValidationEnvelope>;
      const status = axiosError.response?.status;

      if (status === 422 && axiosError.response?.data?.errors) {
         return { status: 'validation', errors: axiosError.response.data.errors };
      }

      if (status === 429) {
         return { status: 'rate_limited' };
      }

      console.error('Tournament entry submission failed', axiosError);
      return {
         status: 'error',
         message: axiosError.response?.data?.message ?? 'Submission failed. Please try again.',
      };
   }
}
